import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaTrash, FaBoxOpen } from "react-icons/fa";
import { HiOutlineSearch, HiOutlinePlusCircle } from "react-icons/hi";
import PageCreateHeader from "../../components/PageCreateHeader";

export default function CreatePaket() {
  const navigate = useNavigate();

  const [search, setSearch] = useState("");
  const [role, setRole] = useState(null);
  const [selectedOutlet, setSelectedOutlet] = useState(null);
  const [outlets, setOutlets] = useState([]);
  const [drugs, setDrugs] = useState([]);
  const [meta, setMeta] = useState({
  current_page: 1,
  last_page: 1,
  total: 0,
  per_page: 10
});
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [name, setName] = useState("");
  const [hargaJual, setHargaJual] = useState("");
  const [tuslah, setTuslah] = useState("");
  const [embalase, setEmbalase] = useState("");

  const filteredDrugs = drugs.filter((item) =>
    item.name.toLowerCase().includes(search.toLowerCase())
  );
// Backend sudah mengatur per_page, jadi tidak perlu slicing manual
const displayedDrugs = filteredDrugs;


  useEffect(() => {
    const userRole = localStorage.getItem("role");
    setRole(userRole);
    if (userRole === "manager") {
      const outletId = localStorage.getItem("id_outlet");
      setSelectedOutlet(outletId);
      fetchDrugs(outletId);
    } else if (userRole === "owner") {
      fetchOutlets();
    }
  }, []);

  const fetchOutlets = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/outlet`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const data = await response.json();
      if (data.success) setOutlets(data.data);
    } catch (error) {
      console.error("Error fetching outlets:", error);
    }
  };
const fetchDrugs = async (outletId, page = 1, searchQuery = "") => {
  try {
    const url = new URL(`${process.env.REACT_APP_API_BASE_URL}/v1/drug`);
    url.searchParams.append("id_outlet", outletId);
    url.searchParams.append("page", page);
    url.searchParams.append("per_page", 10);
    if (searchQuery) url.searchParams.append("search", searchQuery);

    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    const data = await response.json();

    if (data.success) {
      setDrugs(data.data);
      setMeta(data.meta);
    }
  } catch (error) {
    console.error("Error fetching drugs:", error);
  }
};

  const handleAdd = (item) => {
    if (!selectedItems.find((i) => i.id === item.id)) {
      setSelectedItems([...selectedItems, { ...item, qty: 1 }]);
    }
  };

  const handleRemove = (id) => {
    setSelectedItems(selectedItems.filter((item) => item.id !== id));
  };

const handleQtyChange = (id, qty) => {
  if (qty === "") {
    setSelectedItems(selectedItems.map(item =>
      item.id === id ? { ...item, qty: "" } : item
    ));
  } else {
    const newQty = Number(qty);
    if (newQty === 0) {
      setSelectedItems(selectedItems.filter((item) => item.id !== id));
    } else {
      setSelectedItems(selectedItems.map(item =>
        item.id === id ? { ...item, qty: newQty } : item
      ));
    }
  }
};


  const handleSubmit = async () => {
    if (!name || !selectedOutlet || !hargaJual || !tuslah || !embalase || selectedItems.length === 0) {
      alert("Harap isi semua field dan pilih minimal satu obat!");
      return;
    }

    const payload = {
      name,
      outlet_id: Number(selectedOutlet),
      harga_jual: Number(hargaJual),
      tuslah: Number(tuslah),
      embalase: Number(embalase),
      items: selectedItems.map((item) => ({
        drug_id: Number(item.id),
        qty: Number(item.qty)
      }))
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/v1/drug/pack`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (response.ok) {
        alert("Paket berhasil disimpan!");
        navigate("/obat-paket/paket"); // ✅ Redirect here
      } else {
        alert(`Gagal menyimpan paket: ${result.message}`);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
      alert("Terjadi kesalahan saat menyimpan paket.");
    }
  };

  return (
    <div className="min-h-screen flex flex-col space-y-6 p-6 w-full min-w-0">
      <PageCreateHeader
        icon={FaBoxOpen}
        title="Buat Paket Obat"
        description="Susun paket dari beberapa item obat dan harga jual"
        breadcrumbs={[
          { label: "Enterprise", to: "/" },
          { label: "Paket", to: "/obat-paket/paket" },
          { label: "Buat Paket" },
        ]}
      />

    <div className="bg-white rounded-2xl shadow-lg p-6 border border-gray-100 w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Nama</label>
          <input
            type="text"
            placeholder="Nama Paket"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border border-gray-300 rounded-xl p-3 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Harga Jual</label>
          <input
            type="number"
            placeholder="Harga Jual"
            value={hargaJual}
            onChange={(e) => setHargaJual(e.target.value)}
            className="border border-gray-300 rounded-xl p-3 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Tuslah</label>
          <input
            type="number"
            placeholder="Tuslah"
            value={tuslah}
            onChange={(e) => setTuslah(e.target.value)}
            className="border border-gray-300 rounded-xl p-3 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Embalase</label>
          <input
            type="number"
            placeholder="Embalase"
            value={embalase}
            onChange={(e) => setEmbalase(e.target.value)}
            className="border border-gray-300 rounded-xl p-3 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
          />
        </div>
      </div>

      <h3 className="mt-8 text-lg font-semibold text-gray-800">
        Master Obat In Outlet: <span className="text-green-600">{selectedOutlet || "-"}</span>
      </h3>

      {role === "owner" && (
        <select
          className="mt-2 w-full border border-gray-300 p-3 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-400"
          value={selectedOutlet || ""}
          onChange={(e) => {
            setSelectedOutlet(e.target.value);
            fetchDrugs(e.target.value);
          }}
        >
          <option value="">Pilih Outlet</option>
          {outlets.map((outlet) => (
            <option key={outlet.id} value={outlet.id}>
              {outlet.name}
            </option>
          ))}
        </select>
      )}

      {selectedOutlet && (
        <div className="relative mt-4">
          <HiOutlineSearch className="absolute left-3 top-3 text-gray-400" />
          <input
            type="text"
            placeholder="Cari obat..."
            value={search}
            onChange={(e) => {
              const value = e.target.value;
              setSearch(value);
              fetchDrugs(selectedOutlet, 1, value); // kirim ke API
            }}
            className="pl-10 border border-gray-300 rounded-xl p-3 w-full focus:outline-none focus:ring-2 focus:ring-green-400"
          />

        </div>
      )}

      <table className="w-full mt-6 border border-gray-200 rounded-xl overflow-hidden">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3 text-left text-sm font-medium text-gray-700">Name</th>
            <th className="p-3 text-left text-sm font-medium text-gray-700">Stock</th>
            <th className="p-3"></th>
          </tr>
        </thead>
      <tbody>
      {displayedDrugs.map((item) => (
        <tr key={item.id} className="border-t hover:bg-gray-50 transition">
          <td className="p-3">{item.name}</td>
          <td className="p-3">{item.stock}</td>
          <td className="p-3 text-right">
            <button
              className="text-green-600 hover:text-green-800 transition"
              onClick={() => handleAdd(item)}
              title="Tambahkan"
            >
              <HiOutlinePlusCircle className="text-xl" />
            </button>
          </td>
        </tr>
      ))}
    </tbody>

      </table>
<div className="flex justify-between items-center mt-4 text-sm text-gray-600">
  <button
    className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 disabled:opacity-50"
    onClick={() => fetchDrugs(selectedOutlet, meta.current_page - 1)}
    disabled={meta.current_page === 1}
  >
    Previous
  </button>
  <span>
    Page <strong>{meta.current_page}</strong> of {meta.last_page} | Total: {meta.total}
  </span>
  <button
    className="px-4 py-2 bg-gray-200 rounded-full hover:bg-gray-300 disabled:opacity-50"
    onClick={() => fetchDrugs(selectedOutlet, meta.current_page + 1)}
    disabled={meta.current_page === meta.last_page}
  >
    Next
  </button>
</div>


      <table className="w-full mt-6 border border-gray-200 rounded-xl overflow-hidden">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3 text-left text-sm font-medium text-gray-700">Name</th>
            <th className="p-3 text-sm font-medium text-gray-700">Qty</th>
            <th className="p-3"></th>
          </tr>
        </thead>
        <tbody>
          {selectedItems.map((item) => (
            <tr key={item.id} className="border-t hover:bg-gray-50 transition">
              <td className="p-3">{item.name}</td>
              <td className="p-3">
                <input
                  type="number"
                  value={item.qty}
                  onChange={(e) => handleQtyChange(item.id, e.target.value)}
                  className="border border-gray-300 rounded-xl p-2 w-full min-w-0 focus:outline-none focus:ring-1 focus:ring-green-400"
                />
              </td>
              <td className="p-3 text-right">
                <button
                  className="text-red-500 hover:text-red-700 transition"
                  onClick={() => handleRemove(item.id)}
                  title="Hapus"
                >
                  <FaTrash />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        onClick={handleSubmit}
        className="mt-6 w-full bg-green-500 hover:bg-green-600 transition text-white px-6 py-3 rounded-xl font-semibold flex items-center justify-center gap-2"
      >
        <HiOutlinePlusCircle className="text-lg" />
        Simpan Paket
      </button>
    </div>
    </div>
  );
}
